/**
 * Generated with @muse/import-icons
 * Do not edit directly
 */

import { createIcon } from '../lib/create-icon';

export const RssIcon = createIcon(
  '0 0 20 20',
  <g>
    <path d="M4 14a2 2 0 1 1 0 4 2 2 0 0 1 0-4" />
    <path d="M4 8.055a9 9 0 0 1 7.986 8.445c.028.5.014 1 .014 1.5H9c0-.42.012-.843-.006-1.263a6 6 0 0 0-5.206-5.686C3.197 10.974 2.595 11.004 2 11V8c.666 0 1.337-.018 2 .055" />
    <path d="M4 2.033c7.488.493 13.474 6.48 13.967 13.967.044.666.033 1.333.033 2h-3c0-.667.014-1.335-.041-2C14.478 10.17 9.829 5.522 4 5.041 3.335 4.986 2.667 5 2 5V2c.667 0 1.334-.011 2 .033" />
  </g>,
);
